import { render, staticRenderFns } from "./LegoCard.vue?vue&type=template&id=6f8758ba&scoped=true&"
import script from "./LegoCard.vue?vue&type=script&lang=ts&"
export * from "./LegoCard.vue?vue&type=script&lang=ts&"
import style0 from "./LegoCard.vue?vue&type=style&index=0&id=6f8758ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8758ba",
  null
  
)

export default component.exports